import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/common/select";

import { forwardRef, useEffect, useState } from "react";

export const SingleSelect = forwardRef(
  ({ placeholder, options, onChange = () => {}, ...props }) => {
    const [selectedValue, setSelectedValue] = useState(null);

    useEffect(() => {
      if (!options.find((option) => option.value === selectedValue)) {
        setSelectedValue(props.defaultValue || null);
      }
    }, [options, selectedValue, props.defaultValue]);

    const handleChange = (value) => {
      setSelectedValue(value);
      onChange(value);
    };

    return (
      <Select {...props} onValueChange={handleChange} value={selectedValue}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={null}>
            {placeholder || "Selecteer een optie"}
          </SelectItem>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  },
);
